/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateProgramDto } from './create-program-dto';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateAssignmentDto
 */
export interface CreateAssignmentDto {

    /**
     * @type {string}
     * @memberof CreateAssignmentDto
     */
    startAt: string;

    /**
     * @type {string}
     * @memberof CreateAssignmentDto
     */
    endAt: string;

    /**
     * @type {string}
     * @memberof CreateAssignmentDto
     */
    note?: string | null;

    /**
     * @type {CreateProgramDto | JoinEntityDto}
     * @memberof CreateAssignmentDto
     */
    program: CreateProgramDto | JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateAssignmentDto
     */
    sourceProgram?: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateAssignmentDto
     */
    operator?: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateAssignmentDto
     */
    protocol?: JoinEntityDto;
}
